import { type Car } from '../../_types/Car';
import checkUndefinedNullOrEmpty from '../../utils/tools/checkUndefinedNullOrEmpty';
import { CalcFdType } from '../calculator/types';
import type { LowestRate } from './types';

export function getLowestRate(car: Car<false>, exclude?: (CalcFdType | 'leasingComm')[]): LowestRate {
    if (checkUndefinedNullOrEmpty(car)) {
        return undefined;
    }

    const rawLeasingRate = car?.preis?.mwst === 1 ? car?.leasing?.monatliche_rate : undefined;
    const rawLeasingCommRate = car?.preis?.mwst === 1 ? car?.leasingComm?.monatliche_rate_netto : undefined;
    const rawFinancingRate = car?.finanzierung?.monatliche_rate;

    const possibleDefaults: LowestRate[] = [
        checkUndefinedNullOrEmpty(exclude) || !exclude?.includes(CalcFdType.Leasing) ? { type: CalcFdType.Leasing, rate: rawLeasingRate } : undefined,
        checkUndefinedNullOrEmpty(exclude) || !exclude?.includes('leasingComm') ? { type: 'leasingComm' as LowestRate['type'], rate: rawLeasingCommRate } : undefined,
        checkUndefinedNullOrEmpty(exclude) || !exclude?.includes(CalcFdType.Financing) ? { type: CalcFdType.Financing, rate: rawFinancingRate } : undefined,
    ]?.filter((e) => !checkUndefinedNullOrEmpty(e));

    const objectToUse = possibleDefaults?.filter((a) => !checkUndefinedNullOrEmpty(a?.rate))?.sort((a, b) => a.rate - b.rate)?.[0];

    if (!checkUndefinedNullOrEmpty(objectToUse)) {
        return objectToUse;
    }
    return undefined;
}
